<template>
  <b-modal
    id="saveVideoModal"
    modal-class="modal-doom-yoga save-media-modal"
    centered
    lazy
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
  >
    <template #modal-title>
      <span v-if="action_type == 'add'">Add New Video</span>
      <span v-if="action_type == 'edit'">Video Info</span> </template
    ><b-form @submit.prevent="onSubmit">
      <input type="hidden" v-model="type" />
      <b-row class="mt-3">
        <b-col lg="4" md="5">
          <b-row>
            <b-col md="12">
              <p class="error_validation_message_p_dy" v-if="invalid_video">
                Please add video
              </p>
              <div
                class="video-preview-container video-preview-container-doomyoga"
              >
                <VueFileAgent
                  class="mt-2"
                  ref="vueFileAgent"
                  :accept="'video/*'"
                  :multiple="false"
                  :linkable="true"
                  :deletable="true"
                  :meta="true"
                  :resumable="true"
                  @select="filesSelected($event)"
                  @beforedelete="onBeforeDelete($event)"
                  @delete="fileDeleted($event)"
                  v-model="selectedfile"
                >
                  <template v-slot:file-preview-new>
                    <div key="new">
                      <p>Drag and drop file</p>
                      <b-button
                        type="button"
                        variant="doomyoga-danger-outline"
                        class="btn-doom-yoga-submit w-100"
                      >
                        Add Video
                      </b-button>
                    </div>
                  </template>
                </VueFileAgent>
              </div>
              <b-progress
                v-if="is_loading"
                class="progress-bar-doom-yoga my-1"
                max="100"
                height="1rem"
                show-progress
              >
                <b-progress-bar
                  :value="uploadVideoPercentage"
                  :label="uploadVideoPercentage + ' %'"
                ></b-progress-bar>
              </b-progress>
            </b-col>
            <b-col md="12" class="mt-3">
              <p class="error_validation_message_p_dy" v-if="invalid_image">
                Please add cover image
              </p>
              <VueFileAgent
                class="
                  video-preview-container video-preview-container-doomyoga
                  mt-2
                "
                ref="vueFileAgentImg"
                :multiple="false"
                :linkable="true"
                :deletable="true"
                :meta="true"
                :accept="'image/*'"
                @select="filesSelectedImage($event)"
                @beforedelete="onBeforeDeleteImage($event)"
                @delete="fileDeletedImage($event)"
                v-model="selectedfileImage"
              >
                <template v-slot:file-preview-new>
                  <div key="new">
                    <p>Drag and drop file</p>
                    <b-button
                      type="button"
                      variant="doomyoga-danger-outline"
                      class="btn-doom-yoga-submit w-100"
                    >
                      Add Cover Image
                    </b-button>
                  </div>
                </template>
              </VueFileAgent>
              <b-progress
                v-if="is_loading"
                class="progress-bar-doom-yoga my-1"
                max="100"
                height="1rem"
                show-progress
              >
                <b-progress-bar
                  :value="uploadImagePercentage"
                  :label="uploadImagePercentage + ' %'"
                ></b-progress-bar>
              </b-progress>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="8" md="7">
          <b-row>
            <b-col md="12">
              <b-form-group
                label="Video title"
                label-for="video_title"
                :video_title="video_title"
                label-class="form-label-doomyoga"
              >
                <b-form-input
                  id="video_title"
                  class="form-control-doomyoga"
                  v-model="video_title"
                  :video_title="video_title"
                  required
                ></b-form-input>
              </b-form-group> </b-col
            ><b-col md="12">
              <b-form-group
                label="Video description (optional)"
                label-for="video_description"
                :video_description="video_description"
                label-class="form-label-doomyoga"
              >
                <b-form-textarea
                  id="video_description"
                  class="form-control-doomyoga"
                  v-model="video_description"
                  :video_description="video_description"
                  rows="3"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Created by"
                label-for="created_by"
                :created_by="created_by"
                label-class="form-label-doomyoga"
              >
                <b-form-input
                  id="created_by"
                  class="form-control-doomyoga"
                  v-model="created_by"
                  :created_by="created_by"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                class="form-group-vselect-doomyoga"
                label="Category"
                label-for="category"
                :category="category"
                label-class="form-label-doomyoga"
              >
                <p
                  class="error_validation_message_p_dy"
                  v-if="invalid_category"
                >
                  Please select category
                </p>
                <v-select
                  :options="category_list"
                  multiple
                                                    :closeOnSelect="true"
                  name="category"
                  title="category"
                  v-model="category"
                  :value="category"
                  placeholder="Select category"
                  required
                  label="title"
                  :reduce="(item) => item.id"
                  @input="setSelectedCategory"
                >
                </v-select
              ></b-form-group> </b-col
            ><b-col md="12" v-if="category != null && category === 'new'">
              <b-form-group
                label="Category title"
                label-for="category_title"
                :category_title="category_title"
                label-class="form-label-doomyoga"
              >
                <b-form-input
                  id="category_title"
                  class="form-control-doomyoga"
                  v-model="category_title"
                  :category_title="category_title"
                  required
                ></b-form-input>
              </b-form-group> </b-col
            ><b-col md="12" v-if="category != null && category === 'new'">
              <b-form-group
                label="Category description (optional)"
                label-for="category_description"
                :category_description="category_description"
                label-class="form-label-doomyoga"
              >
                <b-form-textarea
                  id="category_description"
                  class="form-control-doomyoga"
                  v-model="category_description"
                  :category_description="category_description"
                  rows="3"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Time duration "
                label-for="time_duration"
                :time_duration="time_duration"
                class=""
                label-class="form-label-doomyoga"
              >
                <!-- <b-form-input
                  id="time_duration"
                  class="form-control-doomyoga"
                 
                  v-model="time_duration"
                  :time_duration="time_duration"
                ></b-form-input> -->
                <span class="form-control form-control-doomyoga">{{
                  time_duration
                }}</span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col> </b-row
      ><b-row class="mt-4">
        <b-col>
          <b-button
            variant="doomyoga-primary"
            class="btn-bumblebee btn-doomyoga btn-doom-yoga-submit float-right"
            type="submit"
            v-if="!is_loading"
          >
            <span v-if="action_type == 'add'">Add Video</span>
            <span v-if="action_type == 'edit'">Save Video</span>
          </b-button>
          <b-button
            type="button"
            disabled
            variant="doomyoga-primary"
            class="btn-bumblebee btn-doomyoga btn-doom-yoga-submit float-right"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import $ from "jquery";
import axios from "axios";

import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
// import '@/assets/js/file-input-preview/piexif.min.js'
// import '@/assets/js/file-input-preview/sortable.min.js'
// import '@/assets/js/file-input-preview/popper.min.js'
// import '@/assets/js/bootstrap.bundle.min.js'
// import '@/assets/js/file-input-preview/fileinput.min.js'
// import '@/assets/js/file-input-preview/theme.js'

import { convertSecToHMSText, formatBytes } from "@/utils/helper-functions.js";

export default {
  name: "SaveVideo",
  props: [
    "type",
    "sub_type",
    "action_type",
    "category_list",
    "category",
    "id",
    "video_title",
    "video_description",
    "created_by",
    "time_duration",
    "video_id",
    "image_id",
    "media_obj",
    "cover_obj",
  ],
  data() {
    return {
      client_name: "DY",
      video_title: "",
      is_loading: false,
      video: null,
      invalid_video: false,
      selectedfile: [],
      selectedfileForUpload: [], // maintain an upload queue
      invalid_image: false,
      selectedfileImage: [],
      selectedfileForUploadImage: [], // maintain an upload queue
      //category: null,
      // category_list: [
      //   { label: "30 min. videos", code: "1" },
      //   { label: "45 min. videos", code: "2" },
      //   { label: "New category", code: "new" },
      // ],
      category_title: "",
      category_description: "",
      invalid_category: false,
      uploadVideoPercentage: 0,
      uploadImagePercentage: 0,
      // video_id: null,
      // image_id: null,
    };
  },
  mounted() {
    console.log("selected cat ", this.category);
    // this.category =[4]
  },
  watch: {
    category(newval, oldval) {
      console.log(newval, oldval);
    },
    media_obj(newval, oldval) {
      console.log(this.selectedfile);
      console.log(newval);
      console.log(oldval);
      this.selectedfile = newval;
      console.log(this.selectedfile);
      // this.selectedfileForUpload = newval;
    },
    cover_obj(newval, oldval) {
      console.log(this.selectedfileImage);
      console.log(newval);
      console.log(oldval);
      this.selectedfileImage = newval;
      console.log(this.selectedfileImage);
      // this.selectedfileForUpload = newval;
    },
  },
  methods: {
    convertSecToHMSText,
    formatBytes,
    setSelectedCategory(value) {
      console.log(value);
      console.log(value.indexOf("new"));
      if (value.indexOf("new") != -1) {
        this.category = this.category_list[this.category_list.length - 1].id;
      }
      console.log(this.category);
    },
    filesSelected(selectedfile) {
      console.log("filesSelected", selectedfile);
      console.log(selectedfile[0].file);

      var validFileRecords = [];
      for (var i = 0; i < selectedfile.length; i++) {
        if (!this.selectedfile[i].error) {
          validFileRecords.push(this.selectedfile[i]);
        }
      }
      console.log("filesSelected", this.selectedfile, validFileRecords);
      this.selectedfileForUpload =
        this.selectedfileForUpload.concat(validFileRecords);

      let temp = this;
      var video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = function () {
        window.URL.revokeObjectURL(video.src);
        var duration = video.duration;
        console.log(duration);
        console.log(duration / 60);
        console.log(duration / 60 / 60);
        console.log(temp.convertSecToHMSText(duration));
        temp.time_duration = temp.convertSecToHMSText(duration);
      };
      video.src = URL.createObjectURL(validFileRecords[0].file);

      console.log(this.selectedfile);
      console.log(this.selectedfileForUpload);
      this.video_id = null;
    },
    filesSelectedImage(selectedfile) {
      console.log("filesSelected", selectedfile);
      var validFileRecords = [];
      for (var i = 0; i < selectedfile.length; i++) {
        if (!this.selectedfileImage[i].error) {
          validFileRecords.push(this.selectedfileImage[i]);
        }
      }
      console.log("filesSelected", this.selectedfileImage, validFileRecords);
      this.selectedfileForUploadImage =
        this.selectedfileForUploadImage.concat(validFileRecords);

      console.log(this.selectedfileImage);
      console.log(this.selectedfileForUploadImage);
      this.image_id = null;
    },
    onBeforeDelete(fileRecord) {
      console.log("in before delete");
      console.log(fileRecord);
      // var i = this.selectedfileForUpload.indexOf(fileRecord);
      // if (i !== -1) {
      //   this.selectedfileForUpload.splice(i, 1);
      //   var k = this.selectedfile.indexOf(fileRecord);
      //   if (k !== -1) this.selectedfile.splice(k, 1);
      // } else {
      //   // if (confirm("Are you sure you want to delete?")) {
      //   // this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
      //   // }
      // }
      this.selectedfile = [];
      this.selectedfileForUpload = [];
      this.video_id = null;
    },
    onBeforeDeleteImage(fileRecord) {
      console.log(fileRecord);
      // var i = this.selectedfileForUploadImage.indexOf(fileRecord);
      // if (i !== -1) {
      //   this.selectedfileForUploadImage.splice(i, 1);
      //   var k = this.selectedfileImage.indexOf(fileRecord);
      //   if (k !== -1) this.selectedfileImage.splice(k, 1);
      // } else {
      //   // if (confirm("Are you sure you want to delete?")) {
      //   // this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
      //   // }
      // }
      this.selectedfileImage = [];
      this.selectedfileForUploadImage = [];
      this.image_id = null;
    },
    fileDeleted(fileRecord) {
      console.log("file deleted");
      console.log(fileRecord);
      var i = this.selectedfileForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.selectedfileForUpload.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileRecord);
      }
      console.log(this.selectedfile);
      console.log(this.selectedfileForUpload);
    },
    fileDeletedImage(fileRecord) {
      console.log(fileRecord);
      var i = this.selectedfileForUploadImage.indexOf(fileRecord);
      if (i !== -1) {
        this.selectedfileForUploadImage.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileRecord);
      }
      console.log(this.selectedfileImage);
      console.log(this.selectedfileForUploadImage);
    },
    deleteUploadedFile: function (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      // this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
    },
    onSubmit(event) {
      console.log(event);
      console.log(this.video_title);
      console.log(this.video_description);
      console.log(this.created_by);
      console.log(this.type);
      console.log(this.category);
      console.log(this.selectedfile);
      console.log(this.selectedfileImage);
      console.log(this.video_id, this.image_id);
      this.is_loading = true;

      if (
        this.category == null ||
        this.category == "" ||
        this.category.length == 0
      ) {
        this.invalid_category = true;
      } else {
        this.invalid_category = false;
      }

      if (this.selectedfile == null || this.selectedfile.length == 0) {
        this.invalid_video = true;
      } else {
        this.invalid_video = false;
      }
      if (
        this.selectedfileImage == null ||
        this.selectedfileImage.length == 0
      ) {
        this.invalid_image = true;
      } else {
        this.invalid_image = false;
      }

      if (
        !this.invalid_video &&
        !this.invalid_image &&
        !this.invalid_category
      ) {
        if (this.action_type == "add") {
          this.uploadMediaRequest("video");
        } else if (this.action_type == "edit") {
          if (this.video_id == null) {
            this.uploadMediaRequest("video");
          } else {
            if (this.image_id == null) {
              this.uploadMediaRequest("image");
            } else {
              if (this.category == "new") {
                // alert("new");
                this.sendSaveCategoryRequest();
              } else {
                this.sendEditVideoRequest();
              }
            }
            //  else {
            //   this.sendEditVideoRequest();
            // }
            // this.sendEditVideoRequest();
          }
          // if(this.video_id == null)
        }
      } else {
        this.is_loading = false;
      }
    },
    uploadMediaRequest(type) {
      console.log("upload media request", type);
      console.log(this.selectedfile[0].file);
      console.log(this.selectedfileImage[0].file);
      let formData = new FormData();
      formData.append("client", this.client_name);
      if (type == "video") {
        formData.append("selectedfile", this.selectedfile[0].file);
      } else if (type == "image") {
        formData.append("selectedfile", this.selectedfileImage[0].file);
      }

      axios
        .post("filesmodule/upload", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
          onUploadProgress: function (progressEvent) {
            console.log("--------", progressEvent.loaded, progressEvent.total);
            if (type == "video") {
              this.uploadVideoPercentage = parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              );
            } else {
              this.uploadImagePercentage = parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              );
            }
          }.bind(this),
        })
        .then((response) => {
          console.log(response);
          //this.is_loading = false;
          // this.cover_image_id = response.data.id;
          // this.getEventDataToSend();
          if (type == "video") {
            this.video_id = response.data.id;
            if (this.action_type == "add") {
              this.uploadMediaRequest("image");
            } else if (this.action_type == "edit") {
              if (this.image_id == null) {
                this.uploadMediaRequest("image");
              } else {
                if (this.category == "new") {
                  // alert("new");
                  this.sendSaveCategoryRequest();
                } else {
                  this.sendEditVideoRequest();
                }
              }
            }
          } else if (type == "image") {
            this.image_id = response.data.id;
            console.log("cont send video data", this.category);
            if (this.action_type == "add") {
              if (this.category == "new") {
                // alert("new");
                this.sendSaveCategoryRequest();
              } else {
                this.sendAddVideoRequest();
              }
            } else if (this.action_type == "edit") {
              if (this.category == "new") {
                // alert("new");
                this.sendSaveCategoryRequest();
              } else {
                this.sendEditVideoRequest();
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.$fire({
            // title: "Title",
            text: error,
            type: "error",
            timer: 5000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    sendAddVideoRequest() {
      console.log("in send save video request");
      console.log(this.video_title, this.video_description);
      console.log(this.created_by, this.time_duration);
      console.log(this.video_id, this.image_id);
      console.log(this.category);
      console.log(this.category_title, this.category_description);

      // return;
      console.log("----------------");
      console.log(this.selectedfile);
      console.log(this.selectedfile[0]);
      console.log(this.selectedfileImage);
      console.log(this.selectedfileImage[0]);
      let formData = new FormData();
      formData.append("title", this.video_title);
      formData.append("title", this.video_title);
      formData.append("description", this.video_description);
      formData.append("media_library", this.type);
      formData.append("sub_library_name", "video");
      formData.append("created_by", this.created_by);
      formData.append("time_duration", this.time_duration);
      formData.append("media_id", this.video_id);
      formData.append("cover_image_id", this.image_id);
      this.category.forEach((item) => {
        formData.append("categories[]", item);
      });

      this.is_loading = true;

      axios
        .post("media/library/add-media", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.image_file);

          this.$fire({
            // title: "Title",
            text: "Video is saved successfully",
            type: "success",
            timer: 3000,
          }).then((r) => {
            this.$bvModal.hide("saveVideoModal");
            this.is_loading = false;
            // this.$parent.$parent.getVideosCategoryList();
            this.$router.go();
          });
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: "Sorry, error in saving video",
            type: "error",
            timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    sendEditVideoRequest() {
      console.log("in send save video request");
      console.log(this.video_title, this.video_description);
      console.log(this.created_by, this.time_duration);
      console.log(this.video_id, this.image_id);
      console.log(this.category);
      console.log(this.category_title, this.category_description);

      // return;
      console.log("----------------");
      console.log(this.selectedfile);
      console.log(this.selectedfile[0]);
      console.log(this.selectedfileImage);
      console.log(this.selectedfileImage[0]);
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("title", this.video_title);
      formData.append("title", this.video_title);
      formData.append("description", this.video_description);
      formData.append("media_library", this.type);
      formData.append("sub_library_name", "video");
      formData.append("created_by", this.created_by);
      formData.append("time_duration", this.time_duration);
      formData.append("media_id", this.video_id);
      formData.append("cover_image_id", this.image_id);
      this.category.forEach((item) => {
        formData.append("categories[]", item);
      });

      this.is_loading = true;

      axios
        .post("media/library/edit-media", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.image_file);

          this.$fire({
            // title: "Title",
            text: "Video is updated successfully",
            type: "success",
            timer: 3000,
          }).then((r) => {
            this.$bvModal.hide("saveVideoModal");
            this.is_loading = false;
            // this.$parent.$parent.getVideosCategoryList();
            this.$router.go();
          });
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: "Sorry, error in saving video",
            type: "error",
            timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    sendSaveCategoryRequest() {
      console.log("in send add cateogry request");
      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("title", this.category_title);
      formData.append("description", this.category_description);
      formData.append("sub_library", "video");
      formData.append("media_library", this.type);

      axios
        .post("category/create", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);

          this.category = [response.data.category.id];
          if (this.action_type == "add") {
            this.sendAddVideoRequest();
          } else if (this.action_type == "edit") {
            this.sendEditVideoRequest();
          }

          // this.$fire({
          //   // title: "Title",
          //   text: "Category is saved successfully",
          //   type: "success",
          //   timer: 3000,
          // }).then((r) => {
          //   this.is_loading = false;
          //   //reset form
          //   this.category_title = "";
          //   this.category_description = "";
          //   this.$bvModal.hide("saveCategoryModal");
          //   console.log(this.$parent.$parent);
          //   this.$parent.$parent.getVideosCategoryList();
          // });
          // this.$router.go();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: "Sorry, error in saving category",
            type: "error",
            timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/media/SaveVideo.vue